import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import { http } from '../../services/HttpInterceptor';
import {
    RouteComponentProps, Link, Redirect
} from "react-router-dom";
import { toast } from 'react-toastify';
import { observable } from 'mobx';
import InputForm from '../site/layout/InputForm';
import { sessionService } from '../../services/SessionService';

interface NewInventoryProps extends RouteComponentProps {
    changeToggle(action?: boolean): void
}

@observer export default class NewInventory extends React.Component<NewInventoryProps> {

    @observable private inventory: any = {
        name: "",
    };
    @observable private redirect = false;
    @observable private validationErrors:string[] = [
        "name",
    ];

    componentDidMount() {
        this.props.changeToggle(true);
    }

    private handleChange = (event: any) => {
        const { name, value } = event.target;
        this.inventory[name] = value;
    }

    private setValidation = (value:boolean, name:string):void =>{
        const error = this.validationErrors.indexOf(name);
        if(value && error === -1) {
            this.validationErrors.push(name);
        } else if(!value && error !== -1) {
            this.validationErrors.splice(error, 1);
        }
    }

    private onSubmit = (): void => {
        this.inventory.created_by = sessionService.getUserInfo().id;

        if (this.validationErrors.length > 0) {
            toast.error("Hay un error en tu formulario");
            return;
        }
        
        http.post(`/api/inventory/create`, JSON.stringify(this.inventory))
            .then(() => {
                toast.success(`Inventario agregado`);
                this.redirect = true;
            }).catch((error)=>{
                if(Array.isArray(error)) {
                    error.forEach((val) =>{
                        toast.error(val);
                    })
                } else {
                    toast.error(error);
                }
            });
    }

    render() {
        if (this.redirect) {
            return <Redirect to="/inventario" />
        }
        return (
            <Fragment>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header card-header-rose card-header-text">
                                <div className="card-text">
                                    <h4 className="card-title">Inventario: {this.inventory.name}</h4>
                                </div>
                            </div>
                            <div className="card-body ">
                                <div className="row">
                                    <div className="col-sm-10"></div>
                                    <div className="col-sm-2">
                                        <Link to={`../antenas`}>
                                            <button className="btn btn-danger btn-sm  pull-right">
                                                <i className="material-icons">highlight_off</i>
                                                <div className="ripple-container"></div>
                                            </button>
                                        </Link>
                                    </div>
                                </div>
                                <InputForm
                                    name="name"
                                    label="Nombre del Inventario"
                                    value={this.inventory.name}
                                    required={true}
                                    setValidation={this.setValidation}
                                    onChange={this.handleChange}
                                    type="text"
                                />
                                <button onClick={this.onSubmit} type="submit" className="btn btn-primary pull-right">Crear Inventario</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment >
        )
    }
}